export const SET_IS_AUTH = "SET_IS_AUTH";
export const GET_USERS = "GET_USERS";
export const TOTAL_PAGES_USERS = "TOTAL_PAGES_USERS";
export const PAGINATION_PARAMS_USERS = "PAGINATION_PARAMS_USERS";
export const COUNT_USERS = "COUNT_USERS";
export const LOGOUT = "LOGOUT";
